import { createApiConstants } from '@saucelabs/sl-util-redux';

const NAMESPACE = 'web-ui-auth';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const INITIALIZE = createApiNamespacedConstants('INITIALIZE');
